import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byId: {}, // { [patientId]: { data: Array, updatedAt: number } }
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      const { id, orders } = action.payload;
      state.byId[id] = { data: orders, updatedAt: Date.now() };
    },
    clearOrders: (state, action) => {
      const id = action.payload;
      if (id) {
        delete state.byId[id];
      } else {
        state.byId = {};
      }
    },
  },
});

export const { setOrders, clearOrders } = ordersSlice.actions;
export default ordersSlice.reducer;
